import axios from 'axios';

const getApiBaseUrl = (envUrl) => {
  if (envUrl) return envUrl;
  
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const port = window.location.port;
    
    // If running on localhost
    if (['localhost', '127.0.0.1'].includes(hostname)) {
      return 'http://localhost:8007/api';
    }
    
    // If running on network IP (192.168.x.x or similar)
    if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) {
      return `http://${hostname}:8007/api`;
    }
  }
  
  // Production domain
  return 'https://klinnovac.id/api';
};

// Frontend Public API (read-only, no auth needed)
const PUBLIC_API = axios.create({
  baseURL: getApiBaseUrl(process.env.REACT_APP_PUBLIC_API_URL),
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
});

// ========== PUBLIC API (Frontend Website) ==========
export const publicApi = {
  getSettings: () => PUBLIC_API.get('/settings'),
  getPages: (slug) => PUBLIC_API.get(`/pages${slug ? `?slug=${slug}` : ''}`),
  getPage: async (slug) => {
    try {
      return await PUBLIC_API.get(`/pages/${encodeURIComponent(slug || '')}`);
    } catch (error) {
      if (error.response?.status === 404 && slug === 'home') {
        return PUBLIC_API.get('/pages/home-klinnovac');
      }
      throw error;
    }
  },
  getPosts: (params) => PUBLIC_API.get('/posts', { params }),
  getPost: (slug) => PUBLIC_API.get(`/posts/${encodeURIComponent(slug || '')}`),
  getSections: (params) => PUBLIC_API.get('/sections', { params }),
  ping: () => PUBLIC_API.get('/ping'),
};

// Public POS API (no auth needed for customer ordering)
const PUBLIC_POS_API = axios.create({
  baseURL: getApiBaseUrl(process.env.REACT_APP_CMS_API_URL),
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
});

export const publicPosApi = {
  getCategories: (params) => PUBLIC_POS_API.get('/public/service-categories', { params }),
  getItems: (params) => PUBLIC_POS_API.get('/public/service-items', { params }),
  getPackages: (params) => PUBLIC_POS_API.get('/public/service-packages', { params }),
  submitOrder: (data) => PUBLIC_POS_API.post('/public/orders', data),
  getWorkerByCode: (cardCode) => PUBLIC_POS_API.get(`/public/worker-by-code/${cardCode}`),
  getWorkerCatalog: (cardCode) => PUBLIC_POS_API.get(`/public/worker/${cardCode}/catalog`),
};
